<template>
  <div class='h100-40 width-100vw h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' :contextMenuItems="contextMenuItems" :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc'
              :excelExportComplete='excelExportComplete' :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true' :actionComplete='actionComplete'>
      <e-columns>
        <e-column type='checkbox'  textAlign='Center' width='66' :displayAsCheckBox='true'></e-column>
        <e-column field='alarmID' :headerText='$t("Alarm.alarmID")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='alarmName' :headerText='$t("Alarm.alarmName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='levelStr' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat'></e-column>
        <e-column field='alarmTypeStr' :headerText='$t("Alarm.alarmType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='typeFormat'></e-column>
        <e-column field='neTypeStr' :headerText='$t("Alarm.neType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' :headerText='$t("Alarm.neName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='equipmentType' :headerText='$t("Alarm.equipmentType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='equipmentName' :headerText='$t("Alarm.equipmentName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neAlarmFDN' :headerText='$t("Alarm.neAlarmFDN")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='clearStateStr' :headerText='$t("Alarm.clearState")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='clearFormat'></e-column>
        <e-column field='confirmStateStr' :headerText='$t("Alarm.confirmState")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='confirmFormat'></e-column>
        <e-column field='createTimeFormat' :headerText='$t("Alarm.createTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='clearTimeFormat' :headerText='$t("Alarm.clearTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='confirmTimeFormat' :headerText='$t("Alarm.confirmTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='clearUsrName' :headerText='$t("Alarm.clearUser")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='confirmUsrName' :headerText='$t("Alarm.confirmUser")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>

        <e-column field='comment' :headerText='$t("Alarm.remark")' :visible='false' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='xxdwinfo1' :headerText='$t("Alarm.xxdwinfo1")' :visible='false' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='xxdwinfo2' :headerText='$t("Alarm.xxdwinfo2")' :visible='false' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='xxkzinfo1' :headerText='$t("Alarm.xxkzinfo1")' :visible='false' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='xxkzinfo2' :headerText='$t("Alarm.xxkzinfo2")' :visible='false' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='xxkzinfo3' :headerText='$t("Alarm.xxkzinfo3")' :visible='false' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='xxkzinfo4' :headerText='$t("Alarm.xxkzinfo4")' :visible='false' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='cause' :headerText='$t("Alarm.cause")' :visible='false' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='advise' :headerText='$t("Alarm.advise")' :visible='false' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getAlarmListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref='detailDialog' :element='detailDialogSetting.element' :styles='detailDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmDetail ref='detailContent'></AlarmDetail>
      </template>
    </CustomDialog>
    <CustomDialog ref='filterDialog' :element='filterDialogSetting.element' :styles='filterDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmFilter url='/lte/ems/fm/alarmhistory/filter' ref='filterContent'></AlarmFilter>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
  import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
  import CustomDialog from '../../common/CustomDialog';
  import AlarmDetail from '../currentAlarm/AlarmDetail';
  import AlarmFilter from '../currentAlarm/AlarmFilter';
  import { EventBus } from '../../../plugins/eventBus';

  export default {
    name: 'historyAlarmTable',
    components: {
      CustomDialog,
      AlarmDetail,
      AlarmFilter
    },
    props: {
      roleNe: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data() {
      return {
        selectionOptions: { type: 'Multiple' },
        contextMenuItems: [{
          text: `${this.$t('Alarm.alarmDetails')}`
        }],
        topoList: [],
        detailDialogSetting: {
          styles: {
            width: '810px',
            height: 'auto',
            model: true,
            visible: false
          },
          element: {
            title: this.$t('Alarm.alarmDetails'),
            target: '#app',
            refName: 'detail',
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.close'), isPrimary: true } }
            ]
          }
        },
        filterDialogSetting: {
          styles: {
            width: '810px',
            height: 'auto',
            model: true,
            visible: false
          },
          element: {
            title: this.$t('Alarm.filterSetting'),
            refName: 'filter',
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
              { click: this.filterConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
            ]
          }
        },
        page: {
          pageNo: 1,
          pageSize: 16,
          totalCount: 0,
          pageCount: 10
        },
        conditionsStatus: false,
        queryConditions: {
          systemId: '1',
          conditions: '', // 告警过滤时会有查询条件，筛调部分告警，初始化时需获取初始条件
          keywords: '', // 模糊查询关键字
        },
        data: []
      };
    },
    provide: {
      grid: [Reorder, Resize, ExcelExport, ContextMenu]
    },
    watch: {
      roleNe() {
        this.getAlarmListData();
      }
    },
    methods: {
      levelFormat(grids, data) {
        data.levelStr = this.$t(`Alarm.alarmLevel_${data.level}`);
        return `<span class='h-alarmLevel${data.level}'>${this.$t(`Alarm.alarmLevel_${data.level}`)}</span>`;
      },
      typeFormat(grids, data) {
        let str = this.$t(`Alarm.alarmType_${data.alarmType}`);
        data.alarmTypeStr = str;
        return str;
      },
      clearFormat(grid, data) {
        let str = this.$t(`Alarm.alarmClearStatus_${data.clearState}`);
        data.clearStateStr = str;
        return str;
      },
      confirmFormat(grid, data) {
        let str = this.$t(`Alarm.alarmConfirmStatus_${data.confirmState}`);
        data.confirmStateStr = str;
        return str;
      },
      menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
        if ((!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) || (this.getCheckedData(true).length > 1)) {
          menuArgs.cancel = true;
        }
      },
      menuClickFunc(menuArgs) { // 为右键分配事件
        switch (menuArgs.element.innerText) {
          case `${this.$t('Alarm.alarmDetails')}`:
            this.showDetail();
            break;
          default:
        }
      },
      dialogHide() {
        this.$refs.detailDialog.clear();
        this.$refs.detailDialog.close();
        this.$refs.filterDialog.clear();
        this.$refs.filterDialog.close();
      },
      getColumnsMapper() {
        return `alarmID:${this.$t('Alarm.alarmID')};`
          + `alarmName:${this.$t('Alarm.alarmName')};`
          + `levelStr:${this.$t('Alarm.alarmLevel')};`
          + `alarmTypeStr:${this.$t('Alarm.alarmType')};`
          + `neTypeStr:${this.$t('Alarm.neType')};`
          + `neName:${this.$t('Alarm.neName')};`
          + `neAlarmFDN:${this.$t('Alarm.neAlarmFDN')};`
          + `clearStateStr:${this.$t('Alarm.clearState')};`
          + `confirmStateStr:${this.$t('Alarm.confirmState')};`
          + `createTimeFormat:${this.$t('Alarm.createTime')};`
          + `clearTimeFormat:${this.$t('Alarm.clearTime')};`
          + `confirmTimeFormat:${this.$t('Alarm.confirmTime')};`
          + `clearUsrName:${this.$t('Alarm.clearUser')};`
          + `confirmUsrName:${this.$t('Alarm.confirmUser')};`
          + `comment:${this.$t('Alarm.remark')};`
          + `xxdwinfo1:${this.$t('Alarm.xxdwinfo1')};`
          + `xxdwinfo2:${this.$t('Alarm.xxdwinfo2')};`
          + `xxkzinfo1:${this.$t('Alarm.xxkzinfo1')};`
          + `xxkzinfo2:${this.$t('Alarm.xxkzinfo2')};`
          + `xxkzinfo3:${this.$t('Alarm.xxkzinfo3')};`
          + `xxkzinfo4:${this.$t('Alarm.xxkzinfo4')};`
          + `cause:${this.$t('Alarm.cause')};`
          + `advise:${this.$t('Alarm.advise')};`;
      },
      getCheckedData(selectOnly) {
        // false: 不支持多选   true: 支持多选
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        if (selectedRecords.length < 1) {
          EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.no_checked')}!`});
          return false;
        }
        if (selectedRecords.length > 1 && !selectOnly) {
          EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Common.tips.onlyOneSelect')}!`});
          return false;
        }
        return selectedRecords;
      },
      getCheckedVals() {
        const messageNos = [];
        const checkedData = this.getCheckedData(true);
        for (let i = 0; i < checkedData.length; i++) {
          messageNos.push(checkedData[i].messageNo);
        }
        return messageNos;
      },
      getAlarmListData(firstFlag) {
        // 获取表格数据
        const This = this;
        let conditionsStr = '';
        let keywordsStr = '';
        if (This.conditionsStatus === true) {
          conditionsStr = This.queryConditions.conditions;
        } else {
          keywordsStr = This.queryConditions.keywords;
        }
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
        if (This.page.pageNo == 1) {
          This.$refs.pager.ej2Instances.currentPage = 1;
        }
        if (firstFlag == true) {
          This.page.pageNo = 1;
          This.$refs.pager.ej2Instances.currentPage = 1;
        }
        EventBus.$emit('loading', { ison: true });
        This.$axios.post('/lte/ems/fm/alarmhistory/queryAlarm.html', {
          page: {
            pageNo: This.page.pageNo,
            pageSize: This.page.pageSize
          },
          keywords: keywordsStr,
          conditions: conditionsStr,
          roleNe: This.roleNe
        }).then((response) => {
          if (response && response.status === 200) {
            EventBus.$emit('loading', { ison: false });
            const result = response.data.resultVal;
            This.page.totalCount = result.totalCount;
            This.data = result.result;
          }
        });
      },
      exportAlarmListData() {
        // 导出选中表格数据
        const checkedData = this.getCheckedData(true);
        if (checkedData) {
          const exportProperties = {
            fileName: `${this.$t('Alarm.historyAlarm')}.xlsx`,
            dataSource: checkedData
          };
          this.$refs.grid.getColumns()[0].visible = false;
          for (let i = 17; i < this.$refs.grid.getColumns().length; i++) {
            this.$refs.grid.getColumns()[i].visible = true;
          }
          this.$refs.grid.excelExport(exportProperties);
        }
      },
      excelExportComplete() {
        this.$refs.grid.getColumns()[0].visible = true;
        for (let i = 17; i < this.$refs.grid.getColumns().length; i++) {
          this.$refs.grid.getColumns()[i].visible = false;
        }
      },
      showDetail() {
        // 告警详情
        const checkedData = this.getCheckedData(false);
        if (checkedData) {
          this.$refs.detailDialog.show();
          this.$refs.detailContent.setAlarmId(checkedData[0]);
        }
      },
      filterFunc() {
        // 告警过滤
        this.$refs.filterDialog.show();
        this.$refs.filterContent.setTopoList(this.topoList);
        this.$refs.filterContent.setConditions(this.queryConditions.conditions);
      },
      filterConfirmFunc(clickEvent) {
        if (clickEvent.keyCode === 13) {
          return;
        }
        // 告警过滤确认事件
        this.queryConditions.conditions = this.$refs.filterContent.getConditions();
        this.topoList = this.$refs.filterContent.getTopoList();
        this.dialogHide();
        this.conditionsStatus = true;
        this.getAlarmListData(true);
      },
      actionComplete() {
        this.$refs.grid.selectRow(0, true);
        this.$refs.grid.selectRow(0, true);
      }
    }
  };
</script>
